import useGetMyProfile, { User } from './useGetMyProfile';

export default useGetMyProfile;
export type { User };
